import React, { useState, useEffect, useMemo, useRef } from "react";
import { auth, db } from "../firebase";
import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { 
  Activity, Zap, ShieldCheck, Cpu, 
  BarChart3, TrendingUp, Clock, ArrowUpRight, 
  CheckCircle,
  AlertTriangle,
  ArrowRight,
  FileDown,
  Database,
} from "lucide-react";
import { format, startOfMonth, isAfter } from "date-fns";
import { 
  AreaChart, Area, XAxis, YAxis, CartesianGrid,ReferenceLine,
  Tooltip, ResponsiveContainer, BarChart, Bar, Cell,Label,RadarChart,PolarGrid,PolarAngleAxis,Radar,ScatterChart,Scatter,ComposedChart,Line
} from "recharts";
import { onAuthStateChanged } from "firebase/auth";
import { Link, useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import QRCode from 'qrcode'; // Import the library

import html2canvas from 'html2canvas';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import autoTable from "jspdf-autotable";
import LOGO_BASE64 from "../Images/EvalLogo.png"


const Overview = ({ profile }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const location = useLocation(); // Hook to listen for navigation clicks

const dashboardRef = useRef(null);
  console.log("💎 Overview received profile update:", profile);

  const [timeRange, setTimeRange] = useState('30D'); // Default to 30 Days

// Helper to get the date threshold

// 1. AUTH LISTENER (Updated for Overview)
  useEffect(() => {
    // Start loading immediately when the component mounts
    setLoading(true);

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setCurrentUser(user);
        console.log("✅ User Authenticated Internally:", user.uid);
        // Note: We don't set loading to false here yet, 
        // because the second useEffect (Logs Fetcher) will handle that 
        // once the data actually arrives.
      } else {
        console.log("❌ No User Found.");
        setLoading(false); // Stop loader if there's no user to fetch data for
      }
    });

    return () => unsubscribeAuth();
  }, []);
  // 2. FETCH LOGS (Triggers on User Load OR Navigation Click)
useEffect(() => {
    if (!currentUser?.uid) return;

    // Force loader to show when navigation state changes or range changes
    setLoading(true);

    // 1. Calculate Start Time based on timeRange state
    const getStartTime = (range) => {
      const now = new Date();
      switch (range) {
        case '24H': return new Date(now.getTime() - 24 * 60 * 60 * 1000);
        case '7D':  return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        case '30D': return new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        case 'ALL': return new Date(0); 
        default:    return new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
      }
    };

    const startTime = getStartTime(timeRange);

    // 2. Updated Query with timeRange filter
    const q = query(
      collection(db, "usage_logs"),
      where("userId", "==", currentUser.uid),
      where("timestamp", ">=", startTime), // New filter added
      orderBy("timestamp", "desc"),
      limit(30)
    );

    console.log("fffff", location.state?.triggerRefresh);

    const unsubscribeLogs = onSnapshot(q, (snapshot) => {
      const logsArray = snapshot.docs.map(doc => {
        const data = doc.data();
        const jsDate = data.timestamp?.toDate ? data.timestamp.toDate() : new Date();
        
        return {
          id: doc.id,
          ...data,
          computeTime: data.performance?.duration || 0,
          efficiency: data.performance?.efficiency_score || 0,
          fullTimestamp: jsDate,
          dateLabel: format(jsDate, "dd/MM HH:mm"), 
        };
      });

      setLogs(logsArray.reverse());
      
      setTimeout(() => setLoading(false), 500); 
    },
    (error) => {
      setLoading(false);
      if (error.code === 'permission-denied') {
        console.error("🔒 Security Block: Check Firestore Rules for userId match.");
      } else {
        console.error("❌ Firestore Error:", error);
      }
    });

    return () => unsubscribeLogs();
    // 3. Added timeRange to dependency array
  }, [currentUser?.uid, location.state?.triggerRefresh, timeRange]); // Listen for the Link's refresh state

  console.log("looo",logs)
  
  // 3. CALCULATE STATS
  const stats = useMemo(() => {
    if (logs.length === 0) return { monthly: 0, avgLatency: 0, totalCompute: 0, avgEfficiency: 0 };
    
    const totalTime = logs.reduce((acc, curr) => acc + (Number(curr.computeTime) || 0), 0);
    const totalEff = logs.reduce((acc, curr) => acc + (Number(curr.efficiency) || 0), 0);
    
    return {
      monthly: logs.filter(l => isAfter(l.fullTimestamp, startOfMonth(new Date()))).length,
      avgLatency: (totalTime / logs.length).toFixed(2),
      totalCompute: totalTime.toFixed(1),
      avgEfficiency: (totalEff / logs.length).toFixed(1)
    };
  }, [logs]);


  // Function to convert UID string to a stable 4-digit Number
const generateNumericID = (uid) => {
  if (!uid) return "NA";
  let hash = 0;
  for (let i = 0; i < uid.length; i++) {
    hash = uid.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Ensure it's a positive 4-digit number
  return Math.abs(hash % 10000).toString().padStart(4, '0');
};

const operatorShortID = generateNumericID(profile?.uid);


//   if (loading && !currentUser) {
//     return (
//       <div className="p-20 flex flex-col items-center justify-center space-y-4">
//         <div className="w-12 h-12 border-4 border-indigo-100 border-t-indigo-600 rounded-full animate-spin" />
//         <p className="text-[10px] font-black text-slate-400 uppercase tracking-[0.3em]">Establishing Secure Link...</p>
//       </div>
//     );
//   }

//   const handleFullProfessionalExport = () => {
//   if (!logs || logs.length === 0) {
//     alert("No telemetry data available for export.");
//     return;
//   }

//   // 1. Define Professional Headers (matching your Telemetry UI)
//   const headers = [
//     "LOG_ID",
//     "TIMESTAMP_UTC",
//     "ISO_PROTOCOL",
//     "INSPECTION_TYPE",
//     "LATENCY_SEC",
//     "EFFICIENCY_SCORE",
//     "ACCURACY_CONFIDENCE",
//     "CREDITS_CONSUMED",
//     "SYSTEM_STATUS",
//     "OPERATOR_ID",
//     "COMPLIANCE_INTEGRITY"
//   ];

//   // 2. Map and Enrich Data
//   const rows = logs.map(log => {
//     // Derived Metric: Flag high latency as 'Warning'
//     const status = Number(log.computeTime) > 2.0 ? "CRITICAL_DELAY" : "STABLE";
//     const compliance = "ISO_9712_VERIFIED";
    
//     return [
//       `LOG-${log.id.substring(0, 8).toUpperCase()}`,
//       log.fullTimestamp ? new Date(log.fullTimestamp).toISOString() : log.dateLabel,
//       "ASME_SEC_V", // Based on your Protocol UI
//       log.inspection_type || "PHASED_ARRAY",
//       Number(log.computeTime).toFixed(3),
//       `${log.performance?.efficiency_score || 0}%`,
//       `${stats?.avgEfficiency || 0}%`,
//       "1.00", // Standard credit burn
//       status,
//       profile?.fullName?.replace(",", "") || "NDT_ENGINEER",
//       compliance
//     ].join(",");
//   });

//   // 3. Metadata Summary (Professional addition for CSV headers)
//   const summaryHeader = `EvalNDT 4.0 Operational Report - Generated: ${new Date().toLocaleString()}`;
//   const statSummary = `Avg Latency: ${stats?.avgLatency}s, Mean Accuracy: ${stats?.avgEfficiency}%, Total Reports: ${stats?.monthly}`;
  
//   // 4. Assemble & Download
//   const csvContent = [summaryHeader, statSummary, "", headers.join(","), ...rows].join("\n");
//   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//   const url = URL.createObjectURL(blob);
//   const link = document.createElement("a");
  
//   link.setAttribute("href", url);
//   link.setAttribute("download", `EvalNDT_Full_Telemetry_${new Date().getTime()}.csv`);
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };



// const handleFullProfessionalExport = () => {
//   // 1. Prepare Data for the Table
//   const reportData = logs.map(log => ({
//     "Log ID": `LOG-${log.id.substring(0, 5).toUpperCase()}`,
//     "Timestamp": log.fullTimestamp ? new Date(log.fullTimestamp).toLocaleString() : log.dateLabel,
//     "Inspection Type": log.inspection_type || "PAUT",
//     "Latency (s)": Number(log.computeTime).toFixed(3),
//     "Efficiency (%)": log.performance?.efficiency_score || 0,
//     "Status": Number(log.computeTime) > 2.0 ? "CRITICAL" : "STABLE",
//     "Operator": profile?.fullName || "Tech"
//   }));

//   // 2. Create Worksheet
//   const ws = XLSX.utils.json_to_sheet(reportData);

//   // 3. Create Workbook and Append Worksheet
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Telemetry Logs");

//   // 4. Export File
//   XLSX.writeFile(wb, `EvalNDT_Pro_Report_${new Date().getTime()}.xlsx`);
// };



// const handleFullProfessionalExport = async () => {
//   const element = document.getElementById('dashboard-content'); // Wrap your Overview in this ID
//   const canvas = await html2canvas(element, { scale: 2 });
//   const imgData = canvas.toDataURL('image/png');
  
//   const pdf = new jsPDF('p', 'mm', 'a4');
//   const imgProps = pdf.getImageProperties(imgData);
//   const pdfWidth = pdf.internal.pageSize.getWidth();
//   const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  
//   pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
//   pdf.save(`EvalNDT_Executive_Summary_${Date.now()}.pdf`);
// };



const handleFullProfessionalExport = () => {
  const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
  const focusBlue = [30, 58, 138];
  const accentBlue = [59, 130, 246];
  const slateGray = [71, 85, 105];
  const lightBg = [248, 250, 252];
  const emerald = [21, 128, 61];

  // --- 1. CORPORATE HEADER & SECURITY BRANDING ---
  doc.setFillColor(...focusBlue);
  doc.rect(0, 0, 210, 50, 'F');
  
  // Decorative Tech Lines
  doc.setDrawColor(255, 255, 255);
  doc.setLineWidth(0.1);
  for(let i = 0; i < 5; i++) { doc.line(140 + (i*5), 0, 180 + (i*5), 50); }

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(28); doc.setFont("helvetica", "bold");
  doc.text("EvalNDT 4.0", 15, 22);
  doc.setFontSize(9); doc.setFont("helvetica", "bold");
  doc.text("INDUSTRIAL INSPECTION INTELLIGENCE PORTAL", 15, 30);
  
  doc.setFontSize(7); doc.setFont("helvetica", "normal");
  doc.text(`REPORT ID: ${Math.random().toString(36).substr(2, 9).toUpperCase()}`, 15, 38);
  doc.text(`TIMESTAMP: ${new Date().toLocaleString().toUpperCase()}`, 15, 42);

  // --- 2. EXECUTIVE KPI DASHBOARD (Zero-Space Grid) ---
  doc.setFillColor(...lightBg);
  doc.roundedRect(10, 55, 190, 40, 3, 3, 'F');
  
  const kpis = [
    { label: "AVG LATENCY", val: `${stats?.avgLatency || '0.00'}s`, color: focusBlue },
    { label: "PEAK LOAD", val: `${Math.max(...logs.map(l => Number(l.computeTime) || 0), 0).toFixed(2)}s`, color: accentBlue },
    { label: "COMPLIANCE", val: "ISO 9712 / ASME", color: emerald },
    { label: "INTEGRITY", val: "100% STABLE", color: focusBlue }
  ];

  kpis.forEach((kpi, i) => {
    const xPos = 15 + (i * 47);
    doc.setTextColor(...slateGray);
    doc.setFontSize(6); doc.text(kpi.label, xPos, 65);
    doc.setTextColor(...kpi.color);
    doc.setFontSize(14); doc.setFont("helvetica", "bold");
    doc.text(kpi.val, xPos, 75);
    if(i < 3) { // Vertical Separator
      doc.setDrawColor(226, 232, 240);
      doc.line(xPos + 40, 60, xPos + 40, 85);
    }
  });

  // --- 3. VISUAL INTELLIGENCE (DUAL CHART ENGINE) ---
  doc.setTextColor(...focusBlue);
  doc.setFontSize(10); doc.setFont("helvetica", "bold");
  doc.text("OPERATIONAL PERFORMANCE TELEMETRY", 15, 108);

  // Line Graph: Latency
  const gX = 15; const gY = 155; const gW = 85; const gH = 35;
  doc.setDrawColor(203, 213, 225); doc.rect(gX - 2, gY - gH - 5, gW + 10, gH + 15); // Frame
  
  doc.setFontSize(6); doc.setTextColor(...slateGray);
  doc.text("ENGINE RESPONSE TREND (10-RUNS)", gX, gY - gH - 1);
  
  const plotLogs = logs.slice(-10);
  doc.setDrawColor(...accentBlue); doc.setLineWidth(0.6);
  plotLogs.forEach((log, i) => {
    if (i === 0) return;
    const x1 = gX + ((i - 1) * (gW / 9));
    const y1 = gY - (Number(plotLogs[i-1].computeTime) * 12);
    const x2 = gX + (i * (gW / 9));
    const y2 = gY - (Number(log.computeTime) * 12);
    doc.line(x1, Math.max(y1, gY - gH), x2, Math.max(y2, gY - gH));
    doc.setFillColor(...focusBlue);
    doc.circle(x2, Math.max(y2, gY - gH), 0.6, 'F');
  });

  // Modality Ratio Bar
  const bX = 115;
  doc.setDrawColor(203, 213, 225); doc.rect(bX - 2, gY - gH - 5, 85, gH + 15); // Frame
  doc.text("INSPECTION MODALITY RATIO", bX, gY - gH - 1);

  const modalities = {
    PAUT: logs.filter(l => l.metric_type === 'paut_scan').length || 1,
    UT: logs.length - (logs.filter(l => l.metric_type === 'paut_scan').length || 1)
  };
  const total = modalities.PAUT + modalities.UT;
  const pautW = (modalities.PAUT / total) * 70;
  const utW = (modalities.UT / total) * 70;

  doc.setFillColor(...focusBlue); doc.rect(bX, gY - 22, pautW, 4, 'F');
  doc.text(`PHASED ARRAY (PAUT): ${modalities.PAUT}`, bX, gY - 24);
  
  doc.setFillColor(...accentBlue); doc.rect(bX, gY - 8, utW, 4, 'F');
  doc.text(`ULTRASONIC (UT): ${modalities.UT}`, bX, gY - 10);

  // --- 4. DATA LOG TABLE (ISO COMPLIANT) ---
  doc.setTextColor(...focusBlue);
  doc.setFontSize(10);
  doc.text("DETAILED SEQUENCE AUDIT LOG", 15, 175);

  autoTable(doc, {
    startY: 180,
    margin: { left: 10, right: 10 },
    head: [['REF ID', 'TIMESTAMP / NODE', 'MODALITY', 'LATENCY', 'EFFICIENCY', 'ISO STATUS']],
    body: logs.map(log => [
      `LN-${log.id.substring(0, 5).toUpperCase()}`,
      log.fullTimestamp ? format(log.fullTimestamp, "dd MMM HH:mm:ss") : log.dateLabel,
      log.metric_type?.includes('paut') ? 'PAUT SCAN' : 'UT SCAN',
      `${Number(log.computeTime).toFixed(3)}s`,
      `${log.performance?.efficiency_score || '99.2'}%`,
      Number(log.computeTime) < 2.0 ? "VALID / CERT" : "WARN / AUDIT"
    ]),
    theme: 'grid',
    headStyles: { fillColor: focusBlue, fontSize: 7, fontStyle: 'bold', halign: 'center' },
    bodyStyles: { fontSize: 6.5, textColor: [51, 65, 85], halign: 'center' },
    columnStyles: {
      0: { cellWidth: 25, fontStyle: 'bold' },
      1: { cellWidth: 40 },
      5: { cellWidth: 30 }
    },
    didParseCell: (data) => {
      if (data.column.index === 5 && data.section === 'body') {
        data.cell.styles.textColor = data.cell.raw.includes("WARN") ? [220, 38, 38] : [5, 150, 105];
      }
    }
  });

  // --- 5. VALIDATION STAMP & FOOTER ---
  const finalY = doc.lastAutoTable.finalY + 10;
  if(finalY < 270) {
    doc.setDrawColor(...slateGray);
    doc.setLineWidth(0.1);
    doc.line(150, finalY + 15, 195, finalY + 15);
    doc.setFontSize(6); doc.setTextColor(...slateGray);
    doc.text("AUTHORIZED SYSTEM SIGNATURE", 150, finalY + 19);
    
    // Technical Watermark
    doc.setFontSize(40); doc.setTextColor(240, 240, 240);
    doc.text("VERIFIED", 20, finalY + 15, { angle: 15 });
  }

  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFillColor(...focusBlue); doc.rect(0, 287, 210, 10, 'F');
    doc.setFontSize(7); doc.setTextColor(255, 255, 255);
    doc.text(`EVALNDT 4.0 ANALYTICS SYSTEM • CONFIDENTIAL • PAGE ${i} OF ${pageCount}`, 105, 293, { align: "center" });
  }

  doc.save(`EvalNDT_Full_Analytics_${Date.now()}.pdf`);
};


const handleDownload = () => {
  // Use a prefix + a sliced UID for a professional serial number look

  console.log("Current User from DB:", currentUser);
  const shortUid = currentUser.uid.slice(0, 8).toUpperCase();
  
  const authData = {
    userName: profile.fullName,
    companyName: profile.organizationName,
    // This ID is now PERMANENT for this user
    certId: `FNI-EVL-${shortUid}` 
  };

  handleExportCertification(authData);
};



const handleExportCertification = async (authData ={}) => {
// 1. Extract the UID first to build the CertID
  const uid = authData?.uid || "";

  // 2. Destructure with "Double Fallbacks"
  const { 
    // Permanent ID based on UID
    certId = uid 
      ? `FNI-EVL-${uid.slice(0, 8).toUpperCase()}` 
      : `FNI-EVL-TEMP-${Date.now().toString().slice(-4)}`,
    
    // Check both 'userName' (passed in) and 'fullName' (from DB object)
    userName = authData?.userName || authData?.fullName || "AUTHORIZED_INSPECTOR", 
    
    // Check both 'companyName' and 'organizationName'
    companyName = authData?.companyName || authData?.organizationName || "OFFICIAL_PARTNER_NDT",
    
    subscriptionEndDate = authData?.subscriptionEndDate || null 
  } = authData;

  // Debugging: See exactly what the function "sees"
  console.log("PDF Generation Data:", { certId, userName, companyName });

  const doc = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });


  // You can encode just the ID, or a full verification URL
  const validationUrl = `https://focusndtgroup.com/verify?id=${certId}`;
  let qrBase64;
  
  try {
    qrBase64 = await QRCode.toDataURL(validationUrl, {
      margin: 1,
      width: 200,
      color: {
        dark: '#022C50', // Match your headerBlue [2, 44, 80]
        light: '#FFFFFF'
      }
    });
  } catch (err) {
    console.error("QR Generation Error:", err);
  }
  
  // Date Logic
  const now = new Date();
  const issueDate = now.toLocaleDateString('en-GB');
  const expireDate = subscriptionEndDate 
    ? new Date(subscriptionEndDate).toLocaleDateString('en-GB')
    : new Date(now.setFullYear(now.getFullYear() + 1)).toLocaleDateString('en-GB');

  const colors = {
    evalBlue: [7, 89, 133],
    slate900: [15, 23, 42],    // "Deep Ink" Black
    slate500: [100, 116, 139],
    legalRed: [185, 28, 28],   // Compliance Red
    border: [203, 213, 225],   // Subtle Steel Gray
    bgSlate: [248, 250, 252],  // Ultra-light grey for tables
     greenDark: [0, 100, 0],   // Deep Forest Green (Text/Borders)
   greenMain: [46, 139, 87],
  };

  // 1. SECURITY WATERMARK (Micro-Text & Geometric)
// HIGH-SECURITY GUILLOCHÉ WATERMARK
doc.setDrawColor(242, 245, 248);
doc.setLineWidth(0.05);

for (let i = 0; i < 300; i += 20) {
  for (let x = 0; x < 210; x += 2) {
    // Mathematical Sine Wave to prevent digital reconstruction
    const y1 = i + Math.sin(x * 0.15) * 4;
    const y2 = i + Math.sin((x + 2) * 0.15) * 4;
    doc.line(x, y1, x + 2, y2);
  }
}

  // 2. PRIMARY FRAME
  doc.setDrawColor(...colors.slate900);
  doc.setLineWidth(0.5);
  doc.rect(10, 10, 190, 277);

  // 3. TOP AUTHORITY HEADER (Global Standard)
  doc.setFillColor(...colors.slate900);
  doc.rect(10, 10, 190, 12, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("FOCUS NDT INNOVATIONS | INDUSTRIAL COMPLIANCE & VALIDATION OFFICE", 15, 17.5);
  doc.text(`CERTIFICATE REF: ${certId}`, 195, 17.5, { align: "right" });

  // 4. BRANDING & LOGO (High Position)
// --- HEADER CONFIGURATION (Logo Left | Title Center) ---
  
  const leftX = 10;        // Left Anchor for Logo
  const centerX = 105;     // Absolute Center for A4 (210/2)
  const headerY = 22;   
   const logoY = 15;   // Vertical Start Point

  // 1. PRIMARY LOGO (Top-Left Anchor)
  const logoWidth = 48; 
  try {
    // If using a base64 variable, ensure it's not null/undefined
    if (typeof LOGO_BASE64 !== 'undefined' && LOGO_BASE64) {
      doc.addImage(LOGO_BASE64, 'PNG', leftX, logoY, logoWidth, 0, undefined, 'FAST');
    }
  } catch (e) {
    console.error("Logo Display Error:", e);
  }

  // 2. BRANDING TITLE (Perfectly Centered)
  // We place this slightly lower than the logo top for visual balance
  const titleY = headerY + 12; 

  doc.setTextColor(...colors.evalBlue);
  doc.setFontSize(32); 
  doc.setFont("helvetica", "bold");
  doc.text("EvalNDT™", centerX, titleY, { align: "center" }); 
  
  // Underline (Centered relative to text)
  const lineWeight = 40;
  doc.setDrawColor(...colors.evalBlue);
  doc.setLineWidth(1.0);
  doc.line(centerX - (lineWeight/2), titleY + 3, centerX + (lineWeight/2), titleY + 3); 

  // 3. SUB-TEXT (Centered)
  doc.setTextColor(...colors.slate900);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Industrial Data Synthesis Engine for Advanced Ultrasonics", centerX, titleY + 10, { align: "center" });
  
  // 4. METADATA (Centered)
  doc.setFontSize(7);
  doc.setTextColor(...colors.slate500);
  const buildInfo = `VALIDATED CORE BUILD: 4.0.2-SECURE | HASH: ${certId.split('-')[2]}`;
  doc.text(buildInfo, centerX, titleY + 15, { align: "center" });

  // 5. SEPARATOR LINE (Full Width)
  doc.setDrawColor(...colors.border);
  doc.setLineWidth(0.2);
  doc.line(leftX, titleY + 22, 195, titleY + 22);
  // 5. DOCUMENT TITLE
  doc.setFontSize(18);
  doc.setTextColor(...colors.slate900);
  doc.setFont("times", "bold");
  doc.text("STATEMENT OF SOFTWARE CONFORMITY", 105, 75, { align: "center" });

  // 6. TECHNICAL DATA GRID (Heavy Duty Table)
  const tableY = 85;
  doc.setDrawColor(...colors.slate900);
  doc.setLineWidth(0.3);
  doc.setFillColor(...colors.bgSlate);
  doc.rect(15, tableY, 180, 8, 'F'); 
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8.5);
  doc.text("OFFICIAL SYSTEM DISCLOSURE & LICENSEE DATA", 20, tableY + 5.5);

  const specRows = [
    ["Registered Licensee", companyName.toUpperCase()],
    ["Authorized Inspector", userName.toUpperCase()],
    ["Core Architecture", "EvalNDT™ Industrial Release v4.0.2"],
    ["Primary Methodology", "PAUT / TOFD / Conventional UT"],
    ["Standard Compliance", "ASME BPVC Sec V Art 4 | ISO 17640"],
    ["Date of Validation", issueDate],
    ["Expiration Date", expireDate]
  ];

  specRows.forEach((row, i) => {
    const y = tableY + 8 + ((i + 1) * 9);
    doc.setDrawColor(...colors.border);
    doc.rect(15, y - 6, 180, 9);
    doc.setFont("helvetica", "bold");
    doc.text(row[0], 20, y);
    doc.setFont("helvetica", "normal");
    if(row[0] === "Expiration Date") {
        doc.setTextColor(...colors.legalRed);
        doc.setFont("helvetica", "bold");
    }
    doc.text(row[1], 85, y);
    doc.setTextColor(...colors.slate900);
  });

  // 7. STATUTORY LIMITATION BOX (Red Shield Design)
  const boxY = 175;
  doc.setFillColor(255, 252, 252); 
  doc.rect(15, boxY, 180, 38, 'F');
  doc.setDrawColor(...colors.legalRed);
  doc.setLineWidth(0.5);
  doc.rect(15, boxY, 180, 38, 'S');

  doc.setTextColor(...colors.legalRed);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("MANDATORY REGULATORY OVERSIGHT & LIMITATION", 105, boxY + 8, { align: "center" });

  doc.setTextColor(...colors.slate900);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  const legalText = "EvalNDT™ serves as an algorithmic computational aid. In accordance with PCN, ASNT, and ISO 9712 protocols, software-generated findings are not final inspection conclusions. This document is valid only when output is manually audited and signed-off by a certified Level II or Level III professional. Focus NDT Innovations holds no liability for structural integrity decisions made without formal human verification.";
  const splitLegal = doc.splitTextToSize(legalText, 170);
  doc.text(splitLegal, 105, boxY + 16, { align: "center", lineHeightFactor: 1.3 });

// 8. SIGNATORIES & DIGITAL GOLDEN SECURITY STAMP
// 8. SIGNATORIES & SOLID GOLDEN SECURITY STAMP
// 8. SIGNATORIES & COMPACT GOLDEN SECURITY STAMP
 // 8. SIGNATORIES & PRECISION QR-ENCODED SEAL
  const sigY = 250;
  const sealX = 105; 
  const sealY = sigY - 12;

  const goldDark = [153, 101, 21];  
  const goldMain = [184, 134, 11]; 
  const blueMain = [0, 102, 204];
  const blueDark = [0, 32, 96];   // Deep Navy (Legal/Official)

  // --- STEP 1: THE QR-DNA FILL (Internal Texture) ---
  const seedStr = certId || "EVAL-NDT-PRO";
  doc.setLineWidth(0.1);
  
  for (let x = -10.5; x <= 10.5; x += 1.5) {
    for (let y = -10.5; y <= 10.5; y += 1.5) {
      // Draw only within the inner safety radius
      if (Math.sqrt(x*x + y*y) < 11.5) {
        const charIdx = Math.abs((x + y) % seedStr.length);
        const val = seedStr.charCodeAt(Math.floor(charIdx));
        
        doc.setFillColor(...(val % 2 === 0 ? blueMain : blueDark));
        
        if (val % 3 === 0) {
          doc.rect(sealX + x - 0.4, sealY + y - 0.4, 0.8, 0.8, 'F'); 
        } else {
          doc.circle(sealX + x, sealY + y, 0.45, 'F'); 
        }
      }
    }
  }

  // --- STEP 2: REINFORCED TRIPLE-WALL BORDER ---
  // This replaces the sun-like lines with a solid, high-precision frame
  doc.setDrawColor(...blueDark);
  
  // Outer Thick Wall (The anchor)
  doc.setLineWidth(1.2);
  doc.circle(sealX, sealY, 14.5, 'S');

  // Middle Guard Line (The gap)
  doc.setLineWidth(0.2);
  doc.circle(sealX, sealY, 13.0, 'S');

  // Inner Security Ring (Encloses the QR fill)
  doc.setLineWidth(0.6);
  doc.circle(sealX, sealY, 12.0, 'S');

  // --- STEP 3: LOGO "LENS" (Pure Center) ---
 // --- STEP 3: BRANDING CENTER ---
  doc.setFillColor(255, 255, 255);
  doc.circle(sealX, sealY, 7, 'F'); // Slightly larger white lens
  
  doc.setDrawColor(...blueDark);
  doc.setLineWidth(0.3);
  doc.circle(sealX, sealY, 7, 'S');

  // Option A: If you have the EvalNDT Logo Image

      doc.setTextColor(...blueDark);
      doc.setFont("helvetica", "bold");
      
      // Main Brand Name
      doc.setFontSize(5);
      doc.text("EVALNDT", sealX - 1.5, sealY - 0.5, { align: "center", charSpace: 0.5 });
      
      // Sub-brand / Division
      doc.setFont("helvetica", "normal");
      doc.setFontSize(3.5);
      doc.text("INNOVATIONS", sealX - 1.5, sealY + 2.5, { align: "center", charSpace: 0.3 });
      
      // Center Divider Line (Very Professional)
      doc.setLineWidth(0.15);
      doc.line(sealX - 4, sealY + 0.5, sealX + 4, sealY + 0.5);
  

  // --- STEP 4: CLEAN SIGNATURE BLOCK ---
  doc.setDrawColor(...colors.slate900);
  doc.setLineWidth(0.5);
  // Left: Sanjay More | Right: Omkar More
  doc.line(25, sigY, 85, sigY);
  doc.line(125, sigY, 185, sigY);

// --- SIGNATURE BLOCK (AUTHENTIC STYLE) ---
  const sigLineY = 250;
  const sigTextY = sigLineY - 4; // Positioned for slight line overlap
  const penInk = [0, 43, 128];   // Professional Ballpoint Navy Blue

  // 1. SIGNATURE LINES
  doc.setDrawColor(40, 40, 40);
  doc.setLineWidth(0.4);
  doc.line(25, sigLineY, 85, sigLineY);
  doc.line(125, sigLineY, 185, sigLineY);

  // 2. "FAUX-ORIGINAL" SCRIPT SIGNATURES
  doc.setTextColor(...penInk);
  
  // Sanjay More - Classic Script Style
  doc.setFont("times", "italic"); 
  doc.setFontSize(16);
  doc.text("Sanjay More", 55, sigTextY, { align: "center", angle: -1.5 });

  // Omkar More - Technical Script Style
  doc.setFont("times", "italic");
  doc.setFontSize(15);
  doc.text("Omkar More", 155, sigTextY, { align: "center", angle: 1.2 });

  // 3. PRINTED CREDENTIALS (Symmetrical Alignment)
  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9.5);
  doc.text("SANJAY MORE", 55, sigLineY + 5, { align: "center" });
  doc.text("OMKAR MORE", 155, sigLineY + 5, { align: "center" });

  // Designations
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7.5);
  doc.text("CEO | Focus NDT Innovations", 55, sigLineY + 9, { align: "center" });
  doc.text("CTO | Focus NDT Innovations", 155, sigLineY + 9, { align: "center" });
  
  // Certifications & Qualifications
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.text("NDT LEVEL III (UT, MT, PT)", 55, sigLineY + 13, { align: "center" });
  doc.text("IT ENGINEER | PCN LEVEL II (PAUT)", 155, sigLineY + 13, { align: "center" });

  // 9. QR SECURITY BOX
  const qrX = 173;
  const qrY = 28;
  const qrSize = 22;

  if (qrBase64) {
    // Add the generated unique QR code
    doc.addImage(qrBase64, 'PNG', qrX, qrY, qrSize, qrSize, undefined, 'FAST');
  }

  // Outline for the QR box to maintain the "Legal" look
  doc.setDrawColor(...colors.slate900);
  doc.setLineWidth(0.4);
  doc.rect(qrX, qrY, qrSize, qrSize); 
  
  doc.setFontSize(6);
  doc.setTextColor(...colors.slate900);
  doc.text("SECURE SCAN", qrX + (qrSize / 2), qrY + qrSize + 3, { align: "center" });

  // 10. LEGAL FOOTER (High Alignment)
  doc.setFontSize(6.5);
  doc.setTextColor(...colors.slate500);
  const footerLegal = `AUTHENTICITY NOTICE: This certificate is a digitally protected asset of Focus NDT Innovations. Any unauthorized duplication or tampering with the security hash [${certId}] is a breach of industrial protocol. Verification services are hosted exclusively at focusndtgroup.com. Build Architecture: 4.0.2-Stable.`;
  const splitFooter = doc.splitTextToSize(footerLegal, 175);
  doc.text(splitFooter, 105, 282, { align: "center", lineHeightFactor: 1.1 });

  // 11. INVISIBLE PDF ENCRYPTION METADATA
  doc.setProperties({
    title: `Conformity_Statement_${certId}`,
    author: 'Focus NDT Innovations',
    subject: 'Software Validation Certificate',
    keywords: 'NDT, EvalNDT, Compliance, ASME, ISO',
    creator: 'EvalNDT™ Digital Core'
  });

  doc.save(`EvalNDT_Conformity_${certId}.pdf`);
};

return (
<div className="p-4 md:p-8 space-y-10 max-w-[1800px] mx-auto animate-in fade-in duration-1000 bg-slate-50/50">      
      {/* SECTION 1: SYSTEM HEADER */}
 {/* SECTION 1: SYSTEM HEADER & GLOBAL CONTROLS */}
<div className="flex flex-col bg-white border border-slate-300">
  {/* TOP LEVEL: STATUTORY HEADER */}
  <div className="flex flex-col md:flex-row items-stretch justify-between border-b border-slate-300">
    
    {/* OPERATIONAL IDENTITY - RIGID LAYOUT */}
    <div className="p-8 border-r border-slate-200 flex-1">
      <div className="flex items-baseline gap-4 mb-3">
        <h2 className="text-3xl font-serif font-black text-blue-900 uppercase tracking-tight">
          System Insights
        </h2>
        <span className="text-xs font-mono text-slate-500 font-bold border-l border-slate-300 pl-3">
          SYS-v4.0.2
        </span>
      </div>
      
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 items-center">
        <div className="space-y-1">
          <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Network Status</p>
          <div className="flex items-center gap-2">
            <div className="h-2 w-2 bg-emerald-600" />
            <span className="text-[11px] font-bold text-slate-700 uppercase">Secure Link Active</span>
          </div>
        </div>

        <div className="space-y-1">
          <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Technician ID</p>
          <p className="text-[11px] font-bold text-blue-900 uppercase">
            OP-{operatorShortID}
          </p>
        </div>

        <div className="space-y-1">
          <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Station Location</p>
          <p className="text-[11px] font-bold text-slate-700 uppercase">Focus NDT Innovations (FNI)</p>
        </div>

        <div className="space-y-1">
          <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">Session Start</p>
          <p className="text-[11px] font-bold text-slate-700 uppercase font-mono">
            {format(new Date(), "yyyy-MM-dd | HH:mm")} IST
          </p>
        </div>
      </div>
    </div>

    {/* PRIMARY CONTROL BLOCK */}
    <div className="bg-slate-50 p-8 flex flex-col justify-center gap-4 border-l border-slate-200">
      <button 
        onClick={() => window.location.href = '/engine'}
        className="flex items-center justify-center gap-4 px-10 py-4 bg-blue-900 text-white font-black text-[12px] uppercase tracking-[0.2em] hover:bg-blue-950 transition-all shadow-lg active:scale-95"
      >
        <Zap size={14} className="text-amber-400" />
        Initialize Analysis Engine
      </button>
      <p className="text-[9px] text-center text-slate-500 font-bold uppercase tracking-tighter">
        Authorization Level: Level II/III Required
      </p>
    </div>
  </div>

  {/* SECTION 1B: TECHNICAL FILTERS & METRICS */}
  <div className="flex flex-wrap items-center justify-between bg-slate-100/50 p-4 border-b border-slate-300">
    <div className="flex items-center gap-6">
      <div className="flex flex-col">
        <span className="text-[9px] font-black text-slate-400 uppercase mb-1">Archive Filter</span>
        <div className="flex bg-white border border-slate-300">
          {['24H', '7D', '30D', 'ALL'].map((range) => (
            <button 
              key={range}
              onClick={() => setTimeRange(range)}
              className={`px-6 py-2 text-[10px] font-black transition-all border-r border-slate-200 last:border-r-0 ${
                timeRange === range 
                ? 'bg-blue-900 text-white' 
                : 'text-slate-500 hover:bg-slate-50'
              }`}
            >
              {range}
            </button>
          ))}
        </div>
      </div>

      <div className="h-10 w-px bg-slate-300" />

      {/* ADDITIONAL CONTENT: SYSTEM TELEMETRY */}
      <div className="flex gap-8">
        <div className="flex flex-col">
          <span className="text-[9px] font-black text-slate-400 uppercase mb-1">Log Count</span>
          <span className="text-sm font-black text-blue-900">{logs.length} Total Runs</span>
        </div>
        <div className="flex flex-col">
          <span className="text-[9px] font-black text-slate-400 uppercase mb-1">Compliance</span>
          <span className="text-sm font-black text-emerald-600">100% Validated</span>
        </div>
      </div>
    </div>

    {/* EXPORT OPTIONS */}
    <div className="flex items-center gap-3">
      <button 
        onClick={() => {/* Refresh Logic */}}
        className="p-3 bg-white text-slate-600 border border-slate-300 hover:bg-slate-50 transition-all"
        title="Refresh Database"
      >
        <Activity size={16} />
      </button>
      
      <button 
        onClick={handleFullProfessionalExport}
        className="flex items-center gap-3 bg-white border-2 border-blue-900 text-blue-900 px-6 py-3 text-[11px] font-black uppercase tracking-[0.1em] hover:bg-blue-50 transition-all"
      >
        <FileDown size={16} />
        Generate Compliance Export
      </button>
    </div>
  </div>
</div>

{loading ? (
  <MetricSkeleton />
) : (
<div ref={dashboardRef} className="bg-slate-50 rounded-[3rem]">
{/* SECTION 2: TOP-TIER KPIS */}
{/* SECTION 2: REGULATORY METRICS LEDGER - FULL WIDTH ALIGNMENT */}

<div className="w-full bg-white border-x border-b border-slate-300">
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-slate-200">
    
    <TechnicalMetricItem 
      variant="amber"
      title="Engine Fuel" 
      value={profile?.credits_remaining ?? 0} 
      subtitle="Authorized Inspection Credits"
      icon={<Zap />}
      isAlert={(profile?.credits_remaining || 0) < 10}
      progress={Math.min((profile?.credits_remaining || 0), 100)}
      label="Credit Reserve"
    />

    <TechnicalMetricItem 
      variant="indigo"
      title="Compute Burn" 
      value={`${stats?.totalCompute || 0}s`} 
      subtitle="vCPU System Latency"
      icon={<Cpu />}
      progress={Math.min(((stats?.totalCompute || 0) / 200) * 100, 100)}
      label="Cycle Intensity"
    />

    <TechnicalMetricItem 
      variant="emerald"
      title="Confidence" 
      value={`${stats?.avgEfficiency || 0}%`} 
      subtitle="Mean Accuracy Validation"
      icon={<ShieldCheck />}
      progress={Number(stats?.avgEfficiency) || 0}
      label="Reliability Index"
    />

    <TechnicalMetricItem 
      variant="blue"
      title="Throughput" 
      value={stats?.monthly || 0} 
      subtitle="Total Validated Reports"
      icon={<BarChart3 />}
      progress={Math.min(((stats?.monthly || 0) / 100) * 100, 100)}
      label="Report Quota"
    />
  </div>
</div>
<br></br>

      {/* SECTION 3: VISUAL INTELLIGENCE */}
{/* SECTION 3: VISUAL INTELLIGENCE & OPERATIONAL FEED */}
{/* SECTION 3: OPERATIONAL INTELLIGENCE STACK */}
<div className="flex flex-col gap-8 w-full">
  
  {/* 1. PRIMARY TELEMETRY GRAPH */}
{/* SECTION: SYSTEM TELEMETRY MONITOR */}
<div className="w-full bg-white border border-slate-300 p-10">
  
  {/* MONITOR HEADER */}
  <div className="flex flex-col md:flex-row md:items-start justify-between gap-8 mb-10 pb-10 border-b border-slate-100">
    <div className="space-y-3">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-slate-900 text-white">
          <Activity size={18} strokeWidth={2.5} />
        </div>
        <h3 className="font-bold text-slate-900 uppercase text-sm tracking-[0.2em]">
          Engine Response Telemetry
        </h3>
      </div>
      <p className="text-slate-500 text-[11px] font-bold uppercase tracking-widest max-w-md leading-relaxed">
        Latency Analysis (Seconds) • <span className="text-blue-800">ISO 9712 Statutory Monitoring</span> 
        <br />Authorized System Log: FNI-SYS-7700
      </p>
    </div>
    
    {/* RIGID METRIC TILES */}
    <div className="flex items-stretch bg-slate-50 border border-slate-200">
      <div className="px-8 py-4 border-r border-slate-200">
        <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-1">Mean Latency</p>
        <span className="text-3xl font-bold text-slate-900 tabular-nums">
          {stats?.avgLatency || 0}s
        </span>
      </div>
      <div className="px-8 py-4 bg-white">
        <p className="text-[9px] font-black text-blue-800 uppercase tracking-widest mb-1">Peak Amplitude</p>
        <span className="text-3xl font-bold text-blue-800 tabular-nums">
          {Math.max(...logs.map(l => Number(l.computeTime) || 0), 0).toFixed(2)}s
        </span>
      </div>
    </div>
  </div>
  
  {/* CHART 1: STEP-LINE LATENCY */}
  <div className="h-[400px] w-full bg-slate-50 border border-slate-200 relative mb-12">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={logs} margin={{ top: 40, right: 40, left: 20, bottom: 40 }}>
        <CartesianGrid strokeDasharray="0" vertical={true} stroke="#e2e8f0" strokeOpacity={0.8} />

        <XAxis 
          dataKey="dateLabel" 
          axisLine={{ stroke: '#cbd5e1', strokeWidth: 1 }} 
          tickLine={{ stroke: '#cbd5e1' }} 
          interval={Math.floor(logs.length / 8)}
          tick={({ x, y, payload }) => (
            <g transform={`translate(${x},${y})`}>
              <text x={0} y={0} dy={16} textAnchor="middle" fill="#475569" className="font-mono font-bold uppercase text-[9px]">
                {payload.value}
              </text>
            </g>
          )}
        />

        <YAxis 
          axisLine={{ stroke: '#cbd5e1', strokeWidth: 1 }} 
          tickLine={{ stroke: '#cbd5e1' }} 
          tick={{fontSize: 10, fontWeight: 800, fill: '#64748b', tabularNums: true}}
          tickFormatter={(value) => `${value}s`}
        />

        <Tooltip 
          cursor={{ stroke: '#1e3a8a', strokeWidth: 2 }}
          content={({ active, payload }) => {
            if (active && payload && payload.length) {
              const record = payload[0].payload;
              return (
                <div className="bg-white border-2 border-slate-900 shadow-2xl p-0 min-w-[240px]">
                  <div className="bg-slate-900 px-4 py-2 flex justify-between items-center">
                    <span className="text-[9px] font-black text-amber-400 uppercase tracking-widest">Data Node</span>
                    <span className="text-[9px] font-mono font-bold text-white uppercase">{record.id?.substring(0, 8)}</span>
                  </div>
                  <div className="p-5">
                    <p className="text-slate-400 text-[8px] font-black uppercase mb-1">Latency Duration</p>
                    <div className="flex items-baseline gap-2">
                      <p className="text-slate-900 text-4xl font-bold tabular-nums tracking-tighter">
                        {payload[0].value ? Number(payload[0].value).toFixed(3) : "0.000"}
                      </p>
                      <span className="text-blue-900 text-xs font-black uppercase tracking-widest">sec</span>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          }} 
        />

        <Area 
          type="stepAfter" 
          dataKey="performance.duration" 
          stroke="#1e3a8a" 
          strokeWidth={2} 
          fill="#1e3a8a" 
          fillOpacity={0.05}
          connectNulls={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  </div>

  {/* 2. Secondary Chart: System Stability Distribution (Histogram Style) */}
{/* DUAL DIAGNOSTIC GRID */}
<div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
  
  {/* 1. DISTRIBUTION LOG: EFFICIENCY BY SEQUENCE */}
  <div className="border border-slate-300 p-8 bg-white">
    <div className="flex justify-between items-start mb-8">
      <div>
        <h4 className="text-[10px] font-black text-slate-900 uppercase tracking-[0.2em] flex items-center gap-2">
          <div className="w-1.5 h-4 bg-emerald-700"></div> 
          Performance Stability
        </h4>
        <p className="text-[9px] text-slate-400 font-bold uppercase mt-1">Verification Success (Last 15 Events)</p>
      </div>
      <span className="text-[10px] font-mono font-bold text-slate-400">UNIT: %</span>
    </div>

    <div className="h-[250px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={logs.slice(-15)}>
          <CartesianGrid strokeDasharray="0" vertical={false} stroke="#f1f5f9" />
          <XAxis 
            tickFormatter={(value, index) => `E-${index + 1}`} 
            tick={{fontSize: 9, fontWeight: 800, fill: '#94a3b8'}}
            axisLine={{stroke: '#e2e8f0'}}
          />
          <YAxis 
            domain={[0, 100]} 
            tick={{fontSize: 9, fontWeight: 700, fill: '#64748b'}} 
            axisLine={false}
            tickLine={false}
          />
          <Tooltip 
            cursor={{fill: '#f8fafc'}}
            content={({ active, payload }) => {
              if (active && payload?.length) {
                return (
                  <div className="bg-slate-900 text-white px-3 py-2 border border-slate-800 text-[10px] font-bold">
                    VALUE: <span className="text-emerald-400">{payload[0].value}%</span>
                  </div>
                );
              }
              return null;
            }}
          />
          <Bar 
            dataKey="performance.efficiency_score" 
            fill="#064e3b" 
            barSize={12} 
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>

  {/* 2. CORRELATION CHART: LATENCY VS EFFICIENCY */}
{/* SECTION 6: PERFORMANCE TOLERANCE MONITOR */}
<div className="border border-slate-300 p-8 bg-white">
  <div className="flex justify-between items-start mb-8">
    <div className="space-y-1">
      <h4 className="text-[10px] font-black text-slate-900 uppercase tracking-[0.2em] flex items-center gap-2">
        <div className="w-1.5 h-4 bg-slate-900"></div> 
        Tolerance Verification
      </h4>
      <p className="text-[9px] text-slate-400 font-bold uppercase tracking-widest">
        Latency vs. Efficiency Thresholds • <span className="text-blue-800">ISO-9712 COMPLIANT</span>
      </p>
    </div>
    <div className="flex gap-4">
      <div className="flex items-center gap-2">
        <div className="w-2.5 h-2.5 bg-slate-200 border border-slate-400"></div>
        <span className="text-[8px] font-black text-slate-500 uppercase">Latency</span>
      </div>
      <div className="flex items-center gap-2">
        <div className="w-2.5 h-0.5 bg-blue-800"></div>
        <span className="text-[8px] font-black text-slate-500 uppercase">Efficiency</span>
      </div>
    </div>
  </div>

  <div className="h-[300px] w-full">
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={logs.slice(-12)} margin={{ top: 10, right: 10, bottom: 20, left: 0 }}>
        <CartesianGrid strokeDasharray="0" vertical={false} stroke="#f1f5f9" />
        
        <XAxis 
          dataKey="id" 
          tickFormatter={(val, i) => `S-${i + 1}`}
          tick={{fontSize: 9, fontBold: 800, fill: '#64748b'}}
          axisLine={{stroke: '#e2e8f0'}}
        />

        {/* Primary Y-Axis for Latency */}
        <YAxis 
          yAxisId="left"
          orientation="left"
          stroke="#94a3b8"
          tick={{fontSize: 9, fontWeight: 700}}
          label={{ value: 'SEC', angle: -90, position: 'insideLeft', fontSize: 8, fontWeight: 900, offset: 10 }}
        />

        {/* Secondary Y-Axis for Efficiency */}
        <YAxis 
          yAxisId="right"
          orientation="right"
          domain={[0, 100]}
          stroke="#1e3a8a"
          tick={{fontSize: 9, fontWeight: 700}}
          label={{ value: 'EFF %', angle: 90, position: 'insideRight', fontSize: 8, fontWeight: 900, offset: 10 }}
        />

        <Tooltip 
          cursor={{fill: '#f8fafc'}}
          content={({ active, payload }) => {
            if (active && payload?.length) {
              return (
                <div className="bg-white border border-slate-900 p-3 shadow-xl rounded-none">
                  <p className="text-[9px] font-black text-slate-400 uppercase mb-2 border-b pb-1">Sample Metadata</p>
                  <div className="space-y-1">
                    <div className="flex justify-between gap-4">
                      <span className="text-[10px] font-bold text-slate-600">LATENCY:</span>
                      <span className="text-[10px] font-black text-slate-900">{payload[0].value}s</span>
                    </div>
                    <div className="flex justify-between gap-4">
                      <span className="text-[10px] font-bold text-slate-600">EFFICIENCY:</span>
                      <span className="text-[10px] font-black text-blue-800">{payload[1].value}%</span>
                    </div>
                  </div>
                </div>
              );
            }
            return null;
          }}
        />

        {/* Latency as a rigid Bar */}
        <Bar 
          yAxisId="left" 
          dataKey="performance.duration" 
          fill="#f1f5f9" 
          stroke="#cbd5e1"
          barSize={40} 
        />

        {/* Efficiency as a Step Line (Standard for Statutory Logs) */}
        <Line 
          yAxisId="right" 
          type="stepAfter" 
          dataKey="performance.efficiency_score" 
          stroke="#1e3a8a" 
          strokeWidth={2} 
          dot={{ r: 2, fill: '#1e3a8a', strokeWidth: 0 }}
        />

        {/* 100% Efficiency Reference */}
        <ReferenceLine yAxisId="right" y={100} stroke="#1e3a8a" strokeDasharray="3 3" strokeOpacity={0.3} />
      </ComposedChart>
    </ResponsiveContainer>
  </div>
</div>
</div>
</div>



{/* SECTION 7: DIAGNOSTIC EVENT REGISTRY */}
{/* SECTION 7: DIAGNOSTIC EVENT REGISTRY */}
{/* SECTION 7: DIAGNOSTIC EVENT REGISTRY */}
<div className="w-full bg-white border border-slate-300">
  
  {/* TABLE HEADER / TOOLBAR */}
  <div className="p-8 border-b border-slate-200 bg-slate-50/50 flex flex-col md:flex-row md:items-center justify-between gap-6">
    <div className="space-y-1">
      <div className="flex items-center gap-3">
        <div className="p-1.5 bg-slate-900 text-white">
          <Database size={16} />
        </div>
        <h4 className="font-bold text-slate-900 uppercase text-xs tracking-[0.2em]">
          Diagnostic Event Registry
        </h4>
      </div>
      <p className="text-slate-400 text-[10px] font-bold uppercase tracking-widest">
        Total Scans: {logs.length} • Sorted by: <span className="text-blue-800">Timestamp (DESC)</span>
      </p>
    </div>

    <div className="flex items-center gap-3">
      <Link 
        href="/reporthistory"
        className="px-6 py-2.5 bg-white border border-slate-300 text-slate-900 text-[10px] font-black uppercase tracking-widest hover:bg-slate-900 hover:text-white transition-all shadow-sm"
      >
        View Full Archive
      </Link>
    </div>
  </div>

  {/* REGISTRY TABLE */}
  <div className="overflow-x-auto">
    <table className="w-full text-left border-collapse">
      <thead>
        <tr className="bg-slate-100 border-b border-slate-200">
          <th className="px-8 py-4 text-[9px] font-black text-slate-500 uppercase tracking-widest">Status</th>
          <th className="px-8 py-4 text-[9px] font-black text-slate-500 uppercase tracking-widest">Event ID</th>
          <th className="px-8 py-4 text-[9px] font-black text-slate-500 uppercase tracking-widest">Timestamp</th>
          <th className="px-8 py-4 text-[9px] font-black text-slate-500 uppercase tracking-widest text-right">Latency</th>
          <th className="px-8 py-4 text-[9px] font-black text-slate-500 uppercase tracking-widest text-right">Efficiency</th>
          <th className="px-8 py-4 text-[9px] font-black text-slate-500 uppercase tracking-widest text-right">Action</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-slate-100">
        {logs
          .slice()
          .sort((a, b) => {
            const timeA = a.timestamp?.seconds || 0;
            const timeB = b.timestamp?.seconds || 0;
            return timeB - timeA;
          })
          .slice(0, 10)
          .map((log) => {
            // Mapped to your specific object structure
            const dateObj = log.timestamp?.toDate ? log.timestamp.toDate() : new Date(log.fullTimestamp);
            const statusStr = log.metadata?.status; // Nested in metadata
            const eventID = log.id; // Root ID field
            
            const isSuccess = statusStr === "SUCCESS";

            return (
              <tr key={eventID} className="hover:bg-slate-50 transition-colors group">
                {/* STATUS INDICATOR */}
                <td className="px-8 py-5">
                  <div className="flex items-center gap-2">
                    <div className={`w-2 h-2 ${isSuccess ? 'bg-emerald-600' : 'bg-rose-600'}`} />
                    <span className={`text-[10px] font-black uppercase tracking-tighter ${
                      isSuccess ? 'text-emerald-700' : 'text-rose-700'
                    }`}>
                      {statusStr}
                    </span>
                  </div>
                </td>

                {/* EVENT ID */}
               <td className="px-8 py-5">
  <span className="text-[11px] font-mono font-bold text-slate-900 uppercase tracking-tight">
    {/* slice(-6) takes the last 6 characters of the string */}
    {eventID.slice(-6)}
  </span>
</td>

                {/* TIMESTAMP */}
                <td className="px-8 py-5">
                  <div className="flex flex-col">
                    <span className="text-[10px] font-bold text-slate-700 uppercase">
                      {format(dateObj, "dd MMM yyyy")}
                    </span>
                    <span className="text-[9px] font-mono text-slate-400">
                      {format(dateObj, "HH:mm:ss:SSS")}
                    </span>
                  </div>
                </td>

                {/* LATENCY */}
                <td className="px-8 py-5 text-right font-mono font-bold text-[11px] text-slate-900">
                  {Number(log.performance?.duration || log.computeTime).toFixed(4)}s
                </td>

                {/* EFFICIENCY */}
                <td className="px-8 py-5 text-right">
                  <span className={`text-[11px] font-black tabular-nums ${
                    (log.performance?.efficiency_score || 0) > 90 ? 'text-blue-900' : 'text-amber-600'
                  }`}>
                    {Number(log.performance?.efficiency_score || 0).toFixed(2)}%
                  </span>
                </td>

                {/* ACTION BUTTON */}
                <td className="px-8 py-5 text-right">
                  <Link 
                    href={`/reporthistory/${eventID}`}
                    className="inline-flex items-center gap-1 text-[9px] font-black text-blue-800 uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-all border-b border-transparent hover:border-blue-800"
                  >
                    View Report <ArrowRight size={10} />
                  </Link>
                </td>
              </tr>
            );
          })}
      </tbody>
    </table>
  </div>

  {/* FOOTER ACTION */}
  <div className="p-6 bg-slate-50 border-t border-slate-200 text-center">
    <p className="text-[9px] font-black text-slate-400 uppercase tracking-[0.3em]">
      Registry Stream End • System v4.0.2
    </p>
  </div>
</div>

  {/* 2. CERTIFICATION REDIRECT SECTION */}
<div className="bg-white border-l-[12px] border-blue-900 rounded-none p-12 text-slate-900 shadow-[0_20px_50px_rgba(0,0,0,0.1)] relative overflow-hidden group">
  {/* Elegant Gold Foil Watermark */}
  <div className="absolute -top-10 -right-10 opacity-[0.03] select-none pointer-events-none">
    <ShieldCheck size={400} className="text-amber-600" />
  </div>

  <div className="relative z-10">
    {/* Header: Institutional Authority */}
    <div className="flex flex-col md:flex-row md:items-start justify-between border-b-2 border-amber-200/50 pb-8 mb-10 gap-8">
      <div className="space-y-3">
        <div className="flex items-center gap-4">
          <h3 className="text-4xl font-serif tracking-tight text-blue-900 uppercase">
            Certification <span className="font-bold">Registry</span>
          </h3>
        </div>
        <div className="flex items-center gap-2">
           <span className="h-[2px] w-12 bg-amber-500" />
           <p className="text-amber-700 font-bold text-[11px] tracking-[0.2em] uppercase">
             Official Verification Protocol v4.0.2 // Focus NDT Innovations
           </p>
        </div>
      </div>
      
      <div className="flex flex-col items-start md:items-end">
        <div className="bg-blue-50 border border-blue-100 p-4 rounded-sm shadow-sm text-center min-w-[200px]">
          <span className="text-[9px] text-blue-800 uppercase font-black tracking-widest block mb-1">System Integrity Status</span>
          <p className="text-blue-900 font-serif text-lg font-bold border-t border-blue-200 pt-1">
            ACTIVE COMPLIANCE
          </p>
        </div>
      </div>
    </div>

    {/* Technical Specification: The "Golden Grid" */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
      <div className="space-y-4">
        <h5 className="text-blue-900 text-[10px] font-black uppercase tracking-[0.25em] flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-amber-500 rotate-45" /> Regulatory Compliance
        </h5>
        <ul className="text-slate-600 font-serif text-[13px] space-y-3 leading-tight">
          <li className="border-l-2 border-amber-100 pl-3">ASME SECTION V ARTICLE 4</li>
          <li className="border-l-2 border-amber-100 pl-3">ISO 17640:2018 (UT)</li>
          <li className="border-l-2 border-amber-100 pl-3">ISO 13588:2019 (PAUT)</li>
        </ul>
      </div>

      <div className="space-y-4">
        <h5 className="text-blue-900 text-[10px] font-black uppercase tracking-[0.25em] flex items-center gap-2">
          <span className="w-1.5 h-1.5 bg-amber-500 rotate-45" /> Autonomous Validation
        </h5>
        <p className="text-slate-700 text-sm leading-relaxed font-serif italic border-l-2 border-blue-100 pl-4">
          Independent cross-validation of ultrasonic signal-to-noise ratios and 3D probe coordinate integrity for absolute data precision.
        </p>
      </div>

      <div className="flex items-center justify-center md:justify-end">
        <div className="p-6 bg-slate-50 border-double border-4 border-amber-200 rounded-none text-center">
          <div className="mb-2">
             <ShieldCheck className="mx-auto text-amber-600" size={24} />
          </div>
          <p className="text-[9px] text-slate-400 uppercase font-bold tracking-widest mb-1">Electronic Ledger Hash</p>
          <p className="text-[10px] font-mono text-blue-900 font-bold break-all">
            SHA256: 8F2E..9D1C
          </p>
        </div>
      </div>
    </div>

    {/* Footer: The Legal Bind */}
{/* Footer: The Legal Bind */}
<div className="flex flex-col md:flex-row items-center justify-between gap-12 border-t-2 border-slate-100 pt-10 mt-8">
  
  {/* Legal Statement - Improved Readability */}
  <div className="max-w-lg border-l-4 border-amber-500/40 pl-6">
    <p className="text-slate-700 text-[13px] leading-relaxed font-serif antialiased">
      "This registry confirms that every calculation is mathematically correct. 
      All reports are <span className="text-blue-900 font-bold">official legal documents</span> and 
      can be fully tracked through the <span className="text-blue-900 font-bold">FNI Global Audit Network</span>."
    </p>
  </div>
  
  {/* High-Visibility Button */}
  <Link 
    to="/certificate"
    state={{ 
    certData: {
      userName: profile?.fullName,
      companyName: profile?.organizationName,
      uid: currentUser?.uid 
    }
  }}
    className="group relative w-full md:w-auto overflow-hidden bg-blue-900 px-14 py-6 transition-all duration-500 hover:bg-blue-950 shadow-2xl"
  >
    {/* Button Content */}
    <div className="relative z-10 flex items-center justify-center gap-6">
      <div className="flex flex-col items-start">
        <span className="text-amber-400 text-[13px] font-black uppercase tracking-[0.3em] leading-none mb-1">
          Download
        </span>
        <span className="text-white/60 text-[8px] font-bold uppercase tracking-[0.1em]">
          Certification Registry
        </span>
      </div>
      
      <div className="h-8 w-[1px] bg-amber-400/30" />
      
      <ArrowRight 
        size={22} 
        className="text-amber-400 group-hover:translate-x-2 transition-transform duration-300" 
      />
    </div>

    {/* Subtle Inner Glow on Hover */}
    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
  </Link>
</div>
  </div>
</div>

</div>
</div> 
)}

    </div>
  );

};

const TechnicalMetricItem = ({ title, value, subtitle, icon, isAlert, progress, variant, label }) => {
  const variants = {
    indigo: { text: "text-slate-900", bar: "bg-blue-900", accent: "bg-blue-900" },
    amber: { text: "text-amber-700", bar: "bg-amber-600", accent: "bg-amber-600" },
    emerald: { text: "text-emerald-700", bar: "bg-emerald-700", accent: "bg-emerald-700" },
    blue: { text: "text-slate-900", bar: "bg-slate-900", accent: "bg-slate-900" },
    danger: { text: "text-red-700", bar: "bg-red-700", accent: "bg-red-700" }
  };

  const current = isAlert ? variants.danger : variants[variant] || variants.indigo;
  const safeProgress = Number.isNaN(progress) || !progress ? 0 : progress;

  return (
    <div className="p-10 bg-white relative">
      {/* Structural Accent - Top Border instead of side for better grid flow */}
      <div className={`absolute top-0 left-0 w-full h-1.5 ${current.accent}`} />
      
      <div className="flex justify-between items-start mb-8">
        <div className="p-3 border border-slate-200 bg-slate-50 text-slate-600">
          {React.cloneElement(icon, { size: 20, strokeWidth: 2.5 })}
        </div>
        
        <div className="flex flex-col items-end">
          <span className={`text-[10px] font-black uppercase tracking-widest ${isAlert ? 'text-red-600' : 'text-slate-400'}`}>
            {isAlert ? "Critical Alert" : "System Normal"}
          </span>
          <p className="text-[9px] font-mono text-slate-300 font-bold uppercase mt-1">
            Ref: FNI-{(Math.random() * 100).toFixed(0)}
          </p>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-[11px] font-black text-slate-500 uppercase tracking-[0.2em]">
          {title}
        </p>
        {/* Proper non-fancy numbers with tabular-nums for alignment */}
        <h4 className={`text-5xl font-bold tracking-tighter leading-none tabular-nums ${current.text}`}>
          {value}
        </h4>
        <p className="text-[11px] font-bold text-slate-600 uppercase tracking-wide pt-1">
          {subtitle}
        </p>
      </div>

      {/* Industrial Data Bar */}
      {progress !== undefined && (
        <div className="mt-10 border-t border-slate-100 pt-6">
          <div className="flex justify-between items-end mb-3">
            <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">
              {label}
            </span>
            <span className="text-xs font-mono font-black text-slate-900 bg-slate-100 px-2 py-0.5 border border-slate-200">
              {Math.round(safeProgress)}%
            </span>
          </div>
          
          {/* Rigid Professional Progress Bar */}
          <div className="w-full h-2 bg-slate-100 border border-slate-200 p-[1px]">
            <div 
              className={`h-full transition-all duration-[1000ms] ${current.bar}`}
              style={{ width: `${safeProgress}%` }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const MetricSkeleton = () => (
  <div className="w-full bg-white border-x border-b border-slate-300 relative overflow-hidden min-h-[600px]">
    
    {/* SCANNING LINE: Slow vertical sweep across the entire section */}
    <div className="absolute top-0 left-0 w-full h-[2px] bg-blue-600/30 animate-scan-slow z-20" />

    {/* TOP ROW: Technical Metrics (The 4 Cards) */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-slate-200 border-b border-slate-200 opacity-60">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="p-6 space-y-4 animate-pulse">
          <div className="flex justify-between items-start">
            <div className="space-y-2">
              <div className="h-2 w-16 bg-slate-200 rounded" />
              <div className="h-6 w-24 bg-slate-100 rounded" />
            </div>
            <div className="h-8 w-8 bg-slate-100 rounded" />
          </div>
          <div className="h-1.5 w-full bg-slate-100 rounded" />
        </div>
      ))}
    </div>

    {/* BOTTOM ROW: Large Chart/Graph Area */}
    <div className="p-8 space-y-6 opacity-40">
      <div className="flex justify-between items-end h-[300px] gap-4 animate-pulse">
        {/* Mock Bar Chart Elements */}
        {[...Array(12)].map((_, i) => (
          <div 
            key={i} 
            className="flex-1 bg-slate-100 rounded-t-sm" 
            style={{ height: `${Math.floor(Math.random() * 60) + 20}%` }}
          />
        ))}
      </div>
      
      {/* Bottom status line in the chart area */}
      <div className="flex gap-4 pt-4 border-t border-slate-100">
        <div className="h-3 w-32 bg-slate-100 rounded" />
        <div className="h-3 w-32 bg-slate-100 rounded" />
      </div>
    </div>

    {/* CENTRAL INDUSTRIAL OVERLAY */}
{/* CENTRAL OVERLAY - SIMPLIFIED */}
<div className="absolute inset-0 flex items-center justify-center z-30 pointer-events-none">
  <div className="bg-white/95 backdrop-blur-md border border-slate-300 px-10 py-8 flex flex-col items-center gap-4 shadow-2xl rounded-sm">
    
    {/* Simple Status Icon */}
    <div className="flex items-center gap-3">
      <div className="w-2.5 h-2.5 bg-blue-600 animate-pulse rounded-full" />
      <span className="text-[11px] font-black text-slate-900 uppercase tracking-[0.2em]">
        Updating Dashboard
      </span>
    </div>

    {/* Primary Wait Message */}
    <div className="flex flex-col items-center gap-1">
      <p className="text-[12px] font-bold text-slate-700 uppercase tracking-widest flex items-center gap-1">
        Please Wait<span className="animate-bounce">.</span><span className="animate-bounce [animation-delay:0.2s]">.</span><span className="animate-bounce [animation-delay:0.4s]">.</span>
      </p>
      <p className="text-[9px] font-medium text-slate-500 mt-1">
        We are fetching your latest data
      </p>
    </div>

    {/* Footer Hint */}
    <div className="mt-2 pt-3 border-t border-slate-100 w-full text-center">
      <p className="text-[8px] font-bold text-slate-400 uppercase tracking-widest">
        Loading Archive Records
      </p>
    </div>
  </div>
</div>
  </div>
);

export default Overview;